var NetworkManager = require("network-manager");

var networkRegister = {
    name: "register",
    mapping:  {
        'CHECK_EMAIL'   : { method: 'GET' , url: 'register/is-email-available?email=:email', expires: 'ALWAYS', label: ''},
        'REGISTER_USER' : { method: 'POST', url: 'register'                                , expires: 'ALWAYS', label: ''},
        'RESET_PASSWORD': { method: 'POST', url: 'password/reset'                          , expires: 'ALWAYS', label: ''},
        'CREATE_LEAD':    { method: 'POST', url: 'register/leads'                       , expires: 'ALWAYS', label: ''},
        'ADD_NON_HEALTH_PROFESSIONAL':    { method: 'POST', url: 'register/non-health-professionals'                       , expires: 'ALWAYS', label: ''},
        'CHANGE_PASSWORD':{ method: 'POST', url: 'password/change-password'},
		'ALL_COUNTRIES': 	{ method: 'GET', url: 'utils/countries'},
        'UPDATE_PASSWORD': { method: 'POST',  url: 'user/change-password', expires: 'ALWAYS', label: ''},
    },

    checkEmailAvilable: function(email) {
        return NetworkManager.action(this.mapping.CHECK_EMAIL, {email: email}, {});
    },
    register: function(form) {
        return NetworkManager.action(this.mapping.REGISTER_USER, {}, form);
    },
    resetPassword: function(email, password, password_confirmation, token) {
        var params = {
            email: email,
            password: password,
            password_confirmation: password_confirmation,
            token: token
        };
        return NetworkManager.action(this.mapping.RESET_PASSWORD, {}, params);
    },
    changePassword: function(password, password_confirmation) {
        var params = {
            password: password,
            password_confirmation: password_confirmation,
        };
        return NetworkManager.action(this.mapping.CHANGE_PASSWORD, {}, params);
    },
    createLead: function(lead) {
        return NetworkManager.action(this.mapping.CREATE_LEAD, {}, lead);
    },
    addNonHeathProfessional: function(userDetail) {
        return NetworkManager.action(this.mapping.ADD_NON_HEALTH_PROFESSIONAL, {}, userDetail);
    },
    getAllCountries: function() {
        return NetworkManager.action(this.mapping.ALL_COUNTRIES, {}, {});
    },
    updatePassword: function (current, password) {
        return NetworkManager.action(this.mapping.UPDATE_PASSWORD, {}, { newPassword: password, oldPassword: current });
    },
};

module.exports = networkRegister;


// WEBPACK FOOTER //
// ./auth/network/networkRegister.js